import React from 'react';
import { useTranslation } from "react-i18next";

function UlytauSightPage(props) 
{
    const { t } = useTranslation();

    return (
        <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
            <h1 className="uk-heading-medium uk-margin-bottom">
                {t("ulytau.title", "Ulytau Mountains")}
            </h1>

            <p className="uk-text-lead uk-margin-bottom">
                {t(
                    "ulytau.intro",
                    "The Ulytau Mountains, located in central Kazakhstan, are both a natural landmark and a cradle of Kazakh history. This mountain range is associated with ancient steppe civilizations, significant historical events, and sacred sites of the Kazakh people."
                )}
            </p>

            <h2 className="uk-heading-line uk-text-bold">
                <span>{t("ulytau.highlightsTitle", "Highlights")}</span>
            </h2>
            <ul className="uk-list uk-list-bullet uk-margin-bottom">
                <li>{t("ulytau.highlight1", "Sacred mountains tied to Kazakh legends and history.")}</li>
                <li>{t("ulytau.highlight2", "Archaeological sites, including ancient burial mounds and petroglyphs.")}</li>
                <li>{t("ulytau.highlight3", "Important historical center where Kazakh khans were elected and buried.")}</li>
                <li>{t("ulytau.highlight4", "Panoramic views of steppe landscapes blending with rocky hills.")}</li>
            </ul>

            <p className="uk-text uk-text-justify">
                {t(
                    "ulytau.conclusion",
                    "The Ulytau Mountains are both a cultural and natural treasure, symbolizing the deep roots of Kazakh identity and offering visitors a journey into the heart of the nation’s history."
                )}
            </p>
        </div>
    );
}

export default UlytauSightPage;
